export interface TimeOnActivitySlot {
  hours: number;
  minutes: number;
}

export interface UnlockDateSlot {
  unlockDate: Date | null;
}

/**
 * Checks if the provided object is a TimeOnActivitySlot by verifying the presence of 'hours' and
 * 'minutes' properties.
 *
 * @param {object} props The object to check for being a TimeOnActivitySlot.
 *
 * @returns {boolean} Indicates if the object is a TimeOnActivitySlot.
 */
export function isTimeOnActivitySlot(props: object): props is TimeOnActivitySlot {
  return 'hours' in props && 'minutes' in props;
}

/**
 * Checks if the provided object is an UnlockDateSlot by verifying the presence of 'unlockDate'
 * property.
 *
 * @param {object} props The object to check for being an UnlockDateSlot.
 *
 * @returns {boolean} Indicates if the object is an UnlockDateSlot.
 */
export function isUnlockDateSlot(props: object): props is UnlockDateSlot {
  return 'unlockDate' in props;
}
